import { CheckCircle2 } from 'lucide-react'

export const PendingApprovalCard = () => (
  <div className="card" style={{ padding: '1.5rem' }}>
    <h1 style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '0.6rem' }}>
      <CheckCircle2 size={28} color="#2563eb" />
      Thanks — we’re reviewing your profile
    </h1>
    <p className="minor" style={{ marginBottom: '0.9rem' }}>
      We manually verify every provider’s credentials. You’ll get an email as soon as your profile is approved.
    </p>
    <ul style={{ margin: '0 0 1.2rem 1rem', padding: 0, color: '#475569', lineHeight: 1.6 }}>
      <li>
        Need to find support across our professions? Visit the{' '}
        <a className="text-link" href="/clients">Clients hub</a> while you wait.
      </li>
      <li>
        Questions or need to update documents? Email{' '}
        <a className="text-link" href="mailto:contact@eucamatch.com">contact@eucamatch.com</a>.
      </li>
    </ul>
    <div className="inline-gap-2" style={{ flexWrap: 'wrap' }}>
      <a className="btn btn-primary" href="/clients">
        Go to Clients hub
      </a>
      <a className="btn" href="/professionals">
        View other professions
      </a>
    </div>
  </div>
)
